<div class="filters-tab flex flex-col center">
    @for (filter of filters; track filter; let i = $index) {
        <div class="filter-item flex center flex-row">
            <mat-form-field appearance="fill" class="filter-field">
                <mat-select placeholder="Column" [(ngModel)]="filter.columnName">
                    @for (column of displayedColumns; track column) {
                        <mat-option [value]="column" required="true">
                            {{ WipHelper.formatColumnName(column) }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <div class="filter-field">
                @switch (filter.columnName) {
                    @case ('jobStatus') {
                        <cb-select-list
                            label="Job Status"
                            [allOptions]="jobStatuses"
                            [multiple]="true"
                            [(value)]="filter.jobStatuses"
                        ></cb-select-list>
                    }
                    @case ('contractType') {
                        <cb-select-list
                            label="Contract Type"
                            [allOptions]="contractTypes"
                            [multiple]="true"
                            [(value)]="filter.contractTypes"
                        ></cb-select-list>
                    }
                    @case ('buildingConsultant') {
                        <cb-user-autocomplete-scroller
                            [tag]="[BUILDING_CONSULTANT]"
                            label="Building Consultant"
                            name="buildingConsultant"
                            [(ngModel)]="buildingConsultantModel"
                            [requireMatch]="true"
                            [matchProps]="['id']"
                            [required]="true"
                            [active]="true">
                        </cb-user-autocomplete-scroller>
                    }
                    @case ('unconditionalDate') {
                        <app-date-filter class="input-value"
                                         [dateValue]="filter.dateValue"
                                         (dateValueChange)="onDateValueChanged($event, filter)">
                        </app-date-filter>
                    }
                    @case ('consentApprovedDate') {
                        <app-date-filter class="input-value"
                                         [dateValue]="filter.dateValue"
                                         (dateValueChange)="onDateValueChanged($event, filter)">
                        </app-date-filter>
                    }
                    @case ('consentLodgedDate') {
                        <app-date-filter class="input-value"
                                         [dateValue]="filter.dateValue"
                                         (dateValueChange)="onDateValueChanged($event, filter)">
                        </app-date-filter>
                    }
                    @case ('consentDueOutDate') {
                        <app-date-filter class="input-value"
                                         [dateValue]="filter.dateValue"
                                         (dateValueChange)="onDateValueChanged($event, filter)">
                        </app-date-filter>
                    }
                    @case ('settlementDate') {
                        <app-date-filter class="input-value"
                                         [dateValue]="filter.dateValue"
                                         (dateValueChange)="onDateValueChanged($event, filter)">
                        </app-date-filter>
                    }
                    @case ('floorDownDate') {
                        <app-date-filter class="input-value"
                                         [dateValue]="filter.dateValue"
                                         (dateValueChange)="onDateValueChanged($event, filter)">
                        </app-date-filter>
                    }
                    @default {
                        <mat-form-field appearance="fill" class="input-value">
                            <input matInput placeholder="Filter Value" [(ngModel)]="filter.filterValue" />
                        </mat-form-field>
                    }
                }
            </div>
            <button mat-icon-button (click)="removeFilter(i)"
                    matTooltip="Delete filter">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    }
    <button mat-button color="primary" (click)="addFilter()">
        <mat-icon>add</mat-icon>
        Add Filter
    </button>
</div>
